export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24px"
      height="24px"
    >
      <g>
        <path
          fill="#000000"
          d="M 9.5,1.5 C 10.8333,1.5 12.1667,1.5 13.5,1.5C 13.5,4.16667 13.5,6.83333 13.5,9.5C 16.1667,9.5 18.8333,9.5 21.5,9.5C 21.5,10.8333 21.5,12.1667 21.5,13.5C 18.8333,13.5 16.1667,13.5 13.5,13.5C 13.5,16.1667 13.5,18.8333 13.5,21.5C 12.1667,21.5 10.8333,21.5 9.5,21.5C 9.5,18.8333 9.5,16.1667 9.5,13.5C 6.83333,13.5 4.16667,13.5 1.5,13.5C 1.5,12.1667 1.5,10.8333 1.5,9.5C 4.16667,9.5 6.83333,9.5 9.5,9.5C 9.5,6.83333 9.5,4.16667 9.5,1.5 Z"
        />
      </g>
    </svg>
  );
};
